export default __webpack_public_path__ + "static/zoom-hero-img-6b910e261c460ad6a049928457dbe950.png";